import { Component, Input, ViewEncapsulation } from '@angular/core';
import * as moment from 'moment';
import { Router } from '@angular/router';
import { jobsFragments } from 'src/admin-app/jobs/jobs.routes';
import { JobSummary } from 'src/shared/api';
import { dateParamFormat } from 'src/shared/constants';

@Component({
	selector: 'rpshared-card-title',
	templateUrl: './card-title.component.html',
	styleUrls: ['./card-title.component.scss'],
	encapsulation: ViewEncapsulation.None,
})
export class CardTitleComponent {
	@Input() icon: string;
	@Input() title: string;
	@Input() isDirty: boolean;
	@Input() jobSummary: JobSummary;

	jobsFragments = jobsFragments;

	constructor(private readonly router: Router) {}

	navigateToScheduling(): void {
		const summaryStart = moment.utc(this.jobSummary.start);
		if (this.jobSummary) {
			if (summaryStart.isAfter(moment.utc())) {
				this.router.navigate(
					jobsFragments.assignments(this.jobSummary.id),
					{
						queryParams: {
							sd: moment
								.utc(summaryStart)
								.startOf('w')
								.format(dateParamFormat),
						},
					}
				);
			} else {
				this.router.navigate(
					jobsFragments.assignments(this.jobSummary.id),
					{
						queryParams: {
							sd: moment
								.utc()
								.startOf('w')
								.format(dateParamFormat),
						},
					}
				);
			}
		}
	}
}
